import intersect from 'turf-intersect';
const polygon = require('turf-helpers').polygon;
import { createNewArray } from '../roofsSelectorClassicDesigner/roofsSelectorClassicDesigner';
import { dispatch, state } from '__common/store';
import { OPEN_CONFIRM_CLEAR_ARRAYS_MODAL, SET_LOCATION, HIDE_CURSOR, SHOW_CURSOR, OPEN_DRAWER_PAGE } from 'actions';

import {
  deleteAllBingShapes,
  getBingRoofOver,
  makeBingRoofEmpty,
  removeBingShape,
  toogleBingRoofSelection,
  redrawBingRoofs,
  goToBingPanelsEditor,
  turnOffBingEditing,
  } from '__editor/bingMapsRoofsSelector/components/bingMapsRoofsSelectorDrawingManager/bingMapsRoofsSelectorDrawingManager';
import {
  deleteAllGoogleRoofs,
  deleteGoogleRoof,
  getGoogleRoofOver,
  makeGoogleRoofEmpty,
  selectGoogleRoof,
  redrawGoogleRoofs,
  goToGooglePanelsEditor,
  } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManager';
import { clearLastZipCode } from '../roofsSelectorMap/roofsSelectorMapEpic';
import { clearAutoSaveProjectTimeout } from '../roofsSelectorSaveLoadProject/saveProject';
import { REMOVE_ROOF_OBSTRUCTIONS, SET_RELOCATION_ACTIVE } from '__editor/panelsEditor/actions';
import { isBlankMap, isGoogleMap } from '__common/constants/map';
import { isCommercialProduct, isEcoFoot2Plus, isRMGridFlex, isSMTiltPR, isAscender, isResidentialProduct, isRMIFIProduct } from '__common/constants/products';
import { RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS } from 'projectDesign/components/projectConfiguration/utils/updateProjectOption';
import { checkFieldNotEmpty } from '../roofsSelectorSaveLoadProject/utils/validateProject';
import { isASCE716or722 } from '__common/constants/buildingCodes';
import { apiField as buildingHeightApiField } from 'projectDesign/components/projectConfiguration/fields/buildingHeight';
import { distanceCheckFromFirstRoofCenter, distanceErrorMessage } from '__editor/googleMapsRoofsSelector/components/drawingManager/utils/roofSizeAlert';
import { apiField as longestBuildingLengthApiField } from 'projectDesign/components/projectConfiguration/fields/longestBuildingLength';
import { apiField as shortestBuildingLengthApiField } from 'projectDesign/components/projectConfiguration/fields/shortestBuildingLength';
import { LOCATION_AND_LOADS_PAGE, RAIL_SYSTEM_PAGE } from 'projectDesign/components/projectConfiguration/utils/projectConfigurationDrawerPages';
import { apiField as buildingCodeApiField } from 'projectDesign/components/projectConfiguration/fields/buildingCode';
import { roofPitchUpdate } from "__common/utils/versionCompare/versionCompare";
import { lat_lng_distance_to_feet } from '__editor/panelsEditor/components/background/utils/backgroundCordinatesConverter';
import { SHARED_CORNER_TOLERANCE_FT } from './utils/consolidatedRoofs';

let editorWidth;
let editorHeight;
let panelsInteractionBlockTimeout;
const panelsInteractionBlockTimeoutTime = 500;

export let panelsInteractionBlock = false;

export function setEditorDims(width, height) {
  editorHeight = height;
  editorWidth = width;
}

export function getEditorDims() {
  return {
    width: editorWidth,
    height: editorHeight,
  };
}

// Remove: once roof pitch 1/12 is available for 716
export function clearRoofsWhenAsce716Or722IsEnabled(currentBuildingCode) {
  const {  drawingManager: { roofs }, projectConfiguration: { projectVersion, projectEnvConfig : { tilt }, productId } } = state();
  
  if(isASCE716or722(currentBuildingCode)) { 
    if (roofs && Object.keys(roofs).length) {
      Object.keys(roofs).map(roofId => {
        if(roofPitchUpdate(projectVersion) ? ['1', '2', '3', '4', '5', '6', '7', '8'].includes(roofs[roofId].roofPitch) : roofs[roofId].roofPitch === '1/12') {
          makeRoofEmpty(Number(roofId)); 
        }
      });
    }
  }
}


export function clearRoofsFromMap() {
  const { drawingManager: { roofs }, roofsSelector: { mapType } } = state();
  if (roofs && Object.keys(roofs).length > 0) {
    if (isGoogleMap(mapType)) {
      deleteAllGoogleRoofs();
    } else {
      deleteAllBingShapes();
    }
  }
}

export function getRoofOver() {
  const { roofsSelector: { mapType } } = state();
  if (isGoogleMap(mapType)) {
    return getGoogleRoofOver();
  }

  return getBingRoofOver();
}

export function makeAllRoofsEmpty() {
  const { drawingManager: { roofs } } = state();

  if (roofs && Object.keys(roofs).length) {
    Object.keys(roofs).map(roofId => makeRoofEmpty(Number(roofId)));
  }
}

export function makeRoofEmpty(roofId: number) {
  const { roofsSelector: { mapType } } = state();
  if (isGoogleMap(mapType)) {
    return makeGoogleRoofEmpty(roofId);
  }

  return makeBingRoofEmpty(roofId);
}

export function selectRoof(roofId: number) {
  const { roofsSelector: { mapType } } = state();
  if (isGoogleMap(mapType)) {
    return selectGoogleRoof(roofId);
  }

  return toogleBingRoofSelection(roofId);
}

export function deleteRoof(roofId: number) {
  const { roofsSelector: { mapType }, drawingManager: {roofs} } = state();
  const numberOfRoofAreas = Object.values(roofs)?.length;

  dispatch(REMOVE_ROOF_OBSTRUCTIONS(roofId));

  if (isGoogleMap(mapType)) {
    return deleteGoogleRoof(roofId);
  }

  removeBingShape(roofId);

  if (isBlankMap(mapType) && Number(roofId) === 1 && numberOfRoofAreas < 2) {
    createNewArray();
  }
}

export function clearRoof(marker: {lat:number, lng:number}, cb: () => void) {
  const { drawingManager: { roofs }, roofsSelectorMap: { location } } = state();
  let oldLocation = location;
  if (roofs && Object.keys(roofs).length > 0 && distanceCheckFromFirstRoofCenter(true, marker)) {
    dispatch(
      OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
        'Change roofarea location',
        'Changing roofarea location will remove all installations. Are you sure?',
        () => {
          clearRoofsFromMap();
          dispatch(SET_RELOCATION_ACTIVE(false));
          distanceErrorMessage(false);
          cb();
        },
        null,
        null,
        SET_LOCATION(oldLocation += ' '),
      ),
    );
  } else {
    cb()
  }
}

export function clearRoofWithWarning(cb: () => void) {
  const { drawingManager: { roofs }, roofsSelectorMap: { location } } = state();
  let oldLocation = location;
  if (roofs && Object.keys(roofs).length > 0) { 
    dispatch(
      OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
        'Change map location',
        'Changing map location will remove all installations. Are you sure?',
        () => {
          clearLastZipCode();
          clearRoofsFromMap();
          cb();
          dispatch(SET_RELOCATION_ACTIVE(false));
        },
        null,
        null,
        SET_LOCATION(oldLocation += ' '),
      ),
    );
  } else {
    clearLastZipCode();
    cb();
  }
}

// A new roof may touch an existing roof ONLY through snapped corners: a shared
// corner point, or a full shared edge whose both ends are snapped corners.
// Any other contact (crossing an edge, a vertex placed on an edge, an edge lying
// partly along another roof's edge, or one roof inside another) is an overlap.

// Planar shoelace area of a closed ring of [x, y] points, in squared degrees.
function ringArea(ring): number {
  if (!ring || ring.length < 3) {
    return 0;
  }
  let area = 0;
  for (let i = 0; i < ring.length - 1; i++) {
    area += ring[i][0] * ring[i + 1][1] - ring[i + 1][0] * ring[i][1];
  }
  return Math.abs(area) / 2;
}

function geometryArea(geometry): number {
  if (!geometry) {
    return 0;
  }
  if (geometry.type === 'Polygon') {
    return ringArea(geometry.coordinates && geometry.coordinates[0]);
  }
  if (geometry.type === 'MultiPolygon') {
    return (geometry.coordinates || []).reduce((sum, poly) => sum + ringArea(poly && poly[0]), 0);
  }
  if (geometry.type === 'GeometryCollection') {
    return (geometry.geometries || []).reduce((sum, g) => sum + geometryArea(g), 0);
  }
  return 0; // LineString / Point / etc. -> shared boundary, no area
}

// Backstop for overlaps the boundary rules cannot see (a new roof drawn on
// three corners of an existing one, or a sliver just inside a shared edge).
const OVERLAP_AREA_THRESHOLD_SQ_FT = 1;
// A point this close to a segment lies on it. Far below the snap tolerance, so
// a round-trip sliver is not mistaken for a vertex placed on the edge.
const ON_SEGMENT_EPSILON_FT = 0.01;
const FEET_PER_DEGREE_LAT = 364567;

interface IRoofVertex {
  lat: number;
  lng: number;
  x: number;
  y: number;
}

function squareFeetPerSquareDegree(lat: number): number {
  return FEET_PER_DEGREE_LAT * FEET_PER_DEGREE_LAT * Math.cos(lat * Math.PI / 180);
}

// polygon2JSON repeats the first corner. That zero-length closer must not be
// walked or sent to turf as a second closing point.
function stripClosingVertex(coords: { lat: number; lng: number }[]): { lat: number; lng: number }[] {
  const open = coords.slice();
  while (open.length > 1 && open[0].lat === open[open.length - 1].lat && open[0].lng === open[open.length - 1].lng) {
    open.pop();
  }
  return open;
}

function toTurfRing(coords: { lat: number; lng: number }[]): number[][] {
  const ring = coords.map(coord => [coord.lat, coord.lng]);
  ring.push(ring[0]);
  return ring;
}

function toRoofVertices(coords: { lat: number; lng: number }[], origin: { lat: number; lng: number }): IRoofVertex[] {
  const feetPerDegreeLng = FEET_PER_DEGREE_LAT * Math.cos(origin.lat * Math.PI / 180);
  return coords.map(coord => ({
    lat: coord.lat,
    lng: coord.lng,
    x: (coord.lng - origin.lng) * feetPerDegreeLng,
    y: (coord.lat - origin.lat) * FEET_PER_DEGREE_LAT,
  }));
}

function samePoint(a: { lat: number; lng: number }, b: { lat: number; lng: number }): boolean {
  return lat_lng_distance_to_feet(a, b) <= SHARED_CORNER_TOLERANCE_FT;
}

function cross(o: IRoofVertex, a: IRoofVertex, b: IRoofVertex): number {
  return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
}

function pointToSegmentDistance(p: IRoofVertex, a: IRoofVertex, b: IRoofVertex): number {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const lengthSq = dx * dx + dy * dy;
  const t = lengthSq ? Math.max(0, Math.min(1, ((p.x - a.x) * dx + (p.y - a.y) * dy) / lengthSq)) : 0;
  return lat_lng_distance_to_feet(p, {
    lat: a.lat + (b.lat - a.lat) * t,
    lng: a.lng + (b.lng - a.lng) * t,
  });
}

function isOnSegment(p: IRoofVertex, a: IRoofVertex, b: IRoofVertex): boolean {
  return pointToSegmentDistance(p, a, b) <= ON_SEGMENT_EPSILON_FT;
}

function isNearBoundary(p: IRoofVertex, poly: IRoofVertex[]): boolean {
  for (let i = 0; i < poly.length; i++) {
    if (pointToSegmentDistance(p, poly[i], poly[(i + 1) % poly.length]) <= SHARED_CORNER_TOLERANCE_FT) {
      return true;
    }
  }
  return false;
}

function segmentsCross(a: IRoofVertex, b: IRoofVertex, c: IRoofVertex, d: IRoofVertex): boolean {
  const d1 = cross(c, d, a);
  const d2 = cross(c, d, b);
  const d3 = cross(a, b, c);
  const d4 = cross(a, b, d);
  return ((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) && ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0));
}

function segmentsTouch(a: IRoofVertex, b: IRoofVertex, c: IRoofVertex, d: IRoofVertex): boolean {
  return segmentsCross(a, b, c, d) || isOnSegment(a, c, d) || isOnSegment(b, c, d)
    || isOnSegment(c, a, b) || isOnSegment(d, a, b);
}

// True when segment a-b touches segment c-d anywhere other than at a common
// snapped corner (or by being the same edge between two such corners).
function hasForbiddenEdgeContact(a: IRoofVertex, b: IRoofVertex, c: IRoofVertex, d: IRoofVertex): boolean {
  if ((a.lat === b.lat && a.lng === b.lng) || (c.lat === d.lat && c.lng === d.lng)) {
    return false;
  }
  if (!segmentsTouch(a, b, c, d)) {
    return false;
  }
  if ((samePoint(a, c) && samePoint(b, d)) || (samePoint(a, d) && samePoint(b, c))) {
    return false;
  }
  const sharedPairs: [IRoofVertex, IRoofVertex][] = [[a, c], [a, d], [b, c], [b, d]];
  const shared = sharedPairs.find(([p, q]) => samePoint(p, q));
  if (!shared) {
    return true;
  }
  const otherNew = shared[0] === a ? b : a;
  const otherExisting = shared[1] === c ? d : c;
  return isOnSegment(otherNew, c, d) || isOnSegment(otherExisting, a, b);
}

function pointInPolygon(p: IRoofVertex, poly: IRoofVertex[]): boolean {
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const a = poly[i];
    const b = poly[j];
    if ((a.y > p.y) !== (b.y > p.y) && p.x < (b.x - a.x) * (p.y - a.y) / (b.y - a.y) + a.x) {
      inside = !inside;
    }
  }
  return inside;
}

function hasVertexInside(vertices: IRoofVertex[], container: IRoofVertex[]): boolean {
  return vertices.some(v => !isNearBoundary(v, container) && pointInPolygon(v, container));
}

function roofsOverlap(newPoly: IRoofVertex[], existingPoly: IRoofVertex[]): boolean {
  for (let i = 0; i < newPoly.length; i++) {
    const a = newPoly[i];
    const b = newPoly[(i + 1) % newPoly.length];
    if (a.lat === b.lat && a.lng === b.lng) {
      continue;
    }
    for (let j = 0; j < existingPoly.length; j++) {
      const c = existingPoly[j];
      const d = existingPoly[(j + 1) % existingPoly.length];
      if (c.lat === d.lat && c.lng === d.lng) {
        continue;
      }
      if (hasForbiddenEdgeContact(a, b, c, d)) {
        return true;
      }
    }
  }
  return hasVertexInside(newPoly, existingPoly) || hasVertexInside(existingPoly, newPoly);
}

export function newRoofOverlaping(newRoofsCoords: { lat: number; lng: number }[], roofId?: string) {
  const roofs = state().drawingManager.roofs;
  const openCoords = newRoofsCoords && stripClosingVertex(newRoofsCoords);

  if (!roofs || Object.keys(roofs).length === 0 || !openCoords || openCoords.length < 3) {
    return false;
  }

  const origin = openCoords[0];
  const newPoly = toRoofVertices(openCoords, origin);
  const newTurfPoly = polygon([toTurfRing(openCoords)]);
  const sqFtPerSqDeg = squareFeetPerSquareDegree(origin.lat);

  return Object.keys(roofs).some(roofName => {
    const roof = roofs[roofName];
    const existingCoords = roof && roof.coords && stripClosingVertex(roof.coords);

    if (Number(roofName) === Number(roofId) || !existingCoords || existingCoords.length < 3) {
      return false;
    }

    if (roofsOverlap(newPoly, toRoofVertices(existingCoords, origin))) {
      return true;
    }

    const turfPoly = polygon([toTurfRing(existingCoords)]);
    const intersection = intersect(turfPoly, newTurfPoly);
    const overlapArea = geometryArea(intersection && intersection.geometry);

    return overlapArea * sqFtPerSqDeg > OVERLAP_AREA_THRESHOLD_SQ_FT;
  });
}

export function redrawRoof() {
  const { roofsSelector: { mapType } } = state();

  if (isGoogleMap(mapType)) {
    return redrawGoogleRoofs();
  }

  return redrawBingRoofs();
}

const openDrawerPage = (invalidFields) => {
  if (invalidFields.has(buildingCodeApiField) || invalidFields.has('zipcode')) {
    dispatch(OPEN_DRAWER_PAGE(LOCATION_AND_LOADS_PAGE));
  }
  else {
    dispatch(OPEN_DRAWER_PAGE(RAIL_SYSTEM_PAGE));
  }
}

export function canGotoPanelsEditor() {
  const { projectConfiguration: { productId, formState: { invalidFields: allInvalidFields }, projectEnvConfig } } = state();

  // restrict to go to panel editor if fields are empty/invalid which affect the setback/wind zone classification
  let invalidFields = new Set<string>();
  if (isRMGridFlex(productId) ) {
    if ( isRMGridFlex(productId) ) {
      RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS.map(field =>  !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
      allInvalidFields.map(({ fieldName }) => RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS.includes(fieldName) && invalidFields.add(fieldName));
    }
  }
  
  if (isCommercialProduct(productId) || isResidentialProduct(productId)){
    let DEFAULT_EMPTY_FIELDS = [buildingHeightApiField];

    if ( (isCommercialProduct(productId)  && !isRMIFIProduct(productId)) || isAscender(productId)   || isSMTiltPR(productId) ) {
      DEFAULT_EMPTY_FIELDS.push(longestBuildingLengthApiField);
    }
    
    if (isResidentialProduct(productId) || isEcoFoot2Plus(productId)) {
        DEFAULT_EMPTY_FIELDS.push(shortestBuildingLengthApiField);
    }

    DEFAULT_EMPTY_FIELDS.map(field =>  !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
    allInvalidFields.map(({ fieldName }) => DEFAULT_EMPTY_FIELDS.includes(fieldName) && invalidFields.add(fieldName));

    if(invalidFields.size){
      openDrawerPage(invalidFields);
      return false;
    }
  }
  
    const DEFAULT_EMPTY_FIELDS = [ 'zipcode' ];
    DEFAULT_EMPTY_FIELDS.map(field => !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
    allInvalidFields.map(({ fieldName }) => DEFAULT_EMPTY_FIELDS.includes(fieldName) && invalidFields.add(fieldName));
  
  if(invalidFields.size){
    openDrawerPage(invalidFields);
    return false;
  }
  return true;
}

export function goToPanelsEditor(roofInfo/* : google.maps.Polygon | Leaflet.LatLng */, roofId: number) {
  
  if (!canGotoPanelsEditor()) return;

  const { roofsSelector: { mapType } } = state();

  clearTimeout(panelsInteractionBlockTimeout);
  clearAutoSaveProjectTimeout();
  turnOffEditing();

  panelsInteractionBlock = true;
  
  dispatch(HIDE_CURSOR());
  
  if (isGoogleMap(mapType)) {
    goToGooglePanelsEditor(roofInfo, roofId);
    panelsInteractionBlockTimeout = setTimeout(
      () => { 
        panelsInteractionBlock = false; 
        dispatch(SHOW_CURSOR());
      }, 
      panelsInteractionBlockTimeoutTime);
    return;
  }

  goToBingPanelsEditor(roofInfo, roofId);
  panelsInteractionBlockTimeout = setTimeout(
    () => { 
      panelsInteractionBlock = false; 
      dispatch(SHOW_CURSOR());
    }, 
    panelsInteractionBlockTimeoutTime);
  return;
}

export function clearPanelsInteractionBlockTimeout() {
  clearTimeout(panelsInteractionBlockTimeout);
}

// Block panel creation for a short window after programmatically entering the
// panels editor. The legacy goToPanelsEditor wrapper sets this internally;
// callers that bypass that wrapper (e.g. UB-Lite's safeDeployRoof, which calls
// goToGooglePanelsEditor directly to skip the canGotoPanelsEditor gate) must
// invoke this so the trailing mouse-up from a double-click that finalized the
// roof doesn't land on the freshly-opened editor and drop a stray panel.
export function blockPanelsInteractionTemporarily() {
  clearTimeout(panelsInteractionBlockTimeout);
  panelsInteractionBlock = true;
  panelsInteractionBlockTimeout = setTimeout(
    () => { panelsInteractionBlock = false; },
    panelsInteractionBlockTimeoutTime);
}

function turnOffEditing() {
  const { roofsSelector: { mapType } } = state();

  if (isGoogleMap(mapType)) {
    // to be done someday;
    return;
  }

  return turnOffBingEditing();
}
